var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-base"},[_c('img',{staticClass:"img",attrs:{"src":'http://'+_vm.ContentImg}}),_c('div',{staticClass:"right-bg"}),_c('div',{staticStyle:{"padding-top":"40px"}},[_c('span',[_vm._v(_vm._s(_vm.ContentDes))])])])}
var staticRenderFns = []

export { render, staticRenderFns }